import React, { Component } from 'react';

interface Props extends JSX.ElementChildrenAttribute {
}

interface State {
  activeMenuItem: string,
  setActiveMenuItem: (activeMenuItem: string) => void
}

export enum TariffView {
  TARIFF_HOME = "/tariff",
  TARIFF_PROCEDURES = "/tariff/procedures",
  TARIFF_PROCEDURES_SELECTION = "/tariff/procedures-selection",
  TARIFF_PROCEDURE_GROUPS = "/tariff/procedure-groups",

}

export const TariffContext = React.createContext<State>({
  activeMenuItem: TariffView.TARIFF_HOME,
  setActiveMenuItem: () => {
  },
});

export class TariffProvider extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      activeMenuItem: TariffView.TARIFF_HOME,
      setActiveMenuItem: this.setActiveMenuItem
    };
  }

  setActiveMenuItem = (activeMenuItem: string) => {
    this.setState({
      activeMenuItem: Object.values(TariffView).includes(activeMenuItem) ?
        activeMenuItem :
          TariffView.TARIFF_HOME,
    });
  };

  render() {
    return (
        <TariffContext.Provider value={this.state}>
          {this.props.children}
        </TariffContext.Provider>
    );
  }
}

export interface TariffConsumerRenderProps extends State {
}

export const withTariffContext = (Component: typeof React.Component | React.FunctionComponent<any>) => {
  return (props: any) => (
    <TariffContext.Consumer>
      {({...tariffProps}: TariffConsumerRenderProps) => {
        return <Component {...props} {...tariffProps} />
      }}
    </TariffContext.Consumer>
  );
};
